import { render, staticRenderFns } from "./catalogueSearchBar.vue?vue&type=template&id=1d2ed632&scoped=true"
import script from "./catalogueSearchBar.vue?vue&type=script&lang=js"
export * from "./catalogueSearchBar.vue?vue&type=script&lang=js"
import style0 from "./catalogueSearchBar.vue?vue&type=style&index=0&id=1d2ed632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ed632",
  null
  
)

export default component.exports